<template>
    <div>
        <v-card
            class="modern-stop-card"
            elevation="12"
            shaped
        >
            <!-- Header modernizado -->
            <v-card-title class="modern-header">
                <v-icon left size="24" color="white">mdi-pause-circle</v-icon>
                <span class="header-title">Paradas de Línea</span>
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    @click="closeDialogStop()"
                    class="close-btn"
                >
                    <v-icon color="white">mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <!-- Contenido del formulario -->
            <v-card-text class="modern-content">
                <!-- Sección de información principal -->
                <div class="form-section">
                    <h3 class="section-title">
                        <v-icon left color="primary">mdi-clock-outline</v-icon>
                        Información General
                    </h3>
                    
                    <v-row class="form-row">
                        <v-col cols="12" md="6">
                            <div class="input-container">
                                <s-date
                                    type="datetime"
                                    label="Fecha y Hora"
                                    v-model="stop.LpsDate"
                                    outlined
                                    dense
                                ></s-date>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="input-container">
                                <s-select-definition
                                    label="Tipo de Parada"
                                    :def="1432"
                                    v-model="stop.TypeCategory"
                                    outlined
                                    dense
                                ></s-select-definition>
                            </div>
                        </v-col>
                    </v-row>
                </div>

                <!-- Sección de responsabilidad -->
                <div class="form-section">
                    <h3 class="section-title">
                        <v-icon left color="orange">mdi-account-supervisor</v-icon>
                        Responsabilidad
                    </h3>
                    
                    <v-row class="form-row">
                        <v-col cols="12">
                            <div class="input-container">
                                <s-select
                                    label="Responsable"
                                    :items="itemResponsible"
                                    item-text="CrpDescription"
                                    item-value="CrpID"
                                    v-model="stop.CrpID"
                                    clearable
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-account"
                                >
                                </s-select>
                            </div>
                        </v-col>
                    </v-row>
                </div>

                <!-- Sección de detalles -->
                <div class="form-section">
                    <h3 class="section-title">
                        <v-icon left color="info">mdi-information-outline</v-icon>
                        Detalles
                    </h3>
                    
                    <v-row class="form-row">
                        <v-col cols="12" md="8">
                            <div class="input-container">
                                <s-select
                                    label="Motivo de la Parada"
                                    :items="itemReason"
                                    item-text="RsdReason"
                                    item-value="RsdID"
                                    v-model="stop.RsdID"
                                    clearable
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-text-box"
                                >
                                </s-select>
                            </div>
                        </v-col>
                        <v-col cols="12" md="4">
                            <div class="input-container">
                                <s-text
                                    label="N° Personas"
                                    v-model="stop.LpsPersonIndirect"
                                    clearable
                                    outlined
                                    dense
                                    type="number"
                                    prepend-inner-icon="mdi-account-group"
                                >
                                </s-text>
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="form-row">
                        <v-col cols="12" md="8">
                            <div class="input-container">
                                 <s-select-definition
                                    label="Modo de Falla"
                                    :def="1690"
                                    v-model="stop.TypeFailureMode"
                                    clearable
                                ></s-select-definition>
                            </div>
                        </v-col>
                    </v-row>
                    <div v-for="(equip, index) in stop.Equipments" :key="index">
    <v-row class="form-row align-center">

        <v-col cols="12" md="5">
            <div class="input-container">
                <s-select-definition
                    label="Equipo"
                    :def="1581"
                    v-model="equip.TypeEquipment"
                    :add="$fun.isAdmin()"
                />
            </div>
        </v-col>

        <v-col cols="12" md="5">
            <div class="input-container">
                <s-select-definition
                    label="Asignación"
                    :def="1582"
                    v-model="equip.TypeAssignment"
                    :add="$fun.isAdmin()"
                />
            </div>
        </v-col>

        <v-col
            cols="12"
            md="2"
            class="d-flex align-center justify-center"
        >

            <v-btn
                v-if="stop.Equipments.length > 1"
                icon
                color="error"
                class="mr-2"
                @click="removeEquipment(index)"
            >
                <v-icon>mdi-minus</v-icon>
            </v-btn>

            <v-btn
                v-if="index === stop.Equipments.length - 1"
                icon
                color="success"
                @click="addEquipment"
            >
                <v-icon>mdi-plus</v-icon>
            </v-btn>

        </v-col>

    </v-row>
</div>
                    <v-row class="form-row">
                        <v-col cols="12" md="12">
                            <div class="input-container">
                                <s-textarea
                                  label="Detalle"
                                  v-model="stop.LpsDetail"
                                  clearable
                                  outlined
                                  dense                                  
                                  prepend-inner-icon="mdi-account-group"
                                >
                                </s-textarea>
                            </div>
                        </v-col>
                       
                    </v-row>
                </div>
            </v-card-text>

            <!-- Footer con botones modernos -->
            <v-card-actions class="modern-actions">
                <v-btn
                    text
                    color="grey"
                    @click="closeDialogStop()"
                    class="cancel-btn"
                >
                    <v-icon left>mdi-close</v-icon>
                    Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                    color="success"
                    @click="saveStop()"
                    class="save-btn"
                    elevation="2"
                >
                    <v-icon left>mdi-content-save</v-icon>
                    Guardar Parada
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
    import _sStop from "@/services/FrozenProduction/FrzCtnLinesProcessStop.js"
    import _sFrzCtnResponsibleStopService from "@/services/FrozenProduction/FrzCtnResponsibleStopService.js";
    
    export default {
        props: {
            lineSelected: {},
        },
        data() {
            return {
                stop: {
                    LpsDate: this.$fun.getDateTimeShortDB(),
                    TypeFailureMode: null,
                    Equipments: [
                        { TypeEquipment: null, TypeAssignment: null }
                    ]
                },
                itemResponsible: [],
                itemReason: [],
            }
        },
        methods: {
            closeDialogStop() {
                this.$emit("closeDialogStop");
            },
            saveStop() {
                this.$fun.alert("¿Seguro de pausar la línea?", "question")
                .then(r => {
                    if(r.value) {
                        this.stop.LpsID = 0;
                        this.stop.ClpID = this.lineSelected.ClpID;
                        this.stop.TypePlace = 1;
                        this.stop.SecStatus = 1;
                        this.stop.UsrCreateID = this.$fun.getUserID();
                        this.stop.UsrUpdateID = this.$fun.getUserID();
                        
                        if (this.stop.Equipments) {
                            this.stop.Equipments.forEach(equip => {
                                equip.LseID = 0;
                                equip.LpsID = 0;
                                equip.SecStatus = 1;
                                equip.UsrCreateID = this.$fun.getUserID();
                                equip.UsrUpdateID = this.$fun.getUserID();
                            });
                        }

                        _sStop
                        .save(this.stop, this.$fun.getUserID())
                        .then(resp => {
                            if(resp.status == 200) {
                                this.$fun.alert("Parada registrada correctamente", "success");
                                this.closeDialogStop();
                                this.$emit("refreshlines");
                                return;
                            }
                        })
                    }
                })
            },
            addEquipment() {
                this.stop.Equipments.push({
                    TypeEquipment: null,
                    TypeAssignment: null
                });
            },
            removeEquipment(index) {
                if (index > 0) {
                    this.stop.Equipments.splice(index, 1);
                }
            },
            ListResponsible() {
                _sFrzCtnResponsibleStopService.listResponsible({}, this.$fun.getUserID())
                .then(resp => {
                    if(resp.status == 200) {
                        this.itemResponsible = resp.data;
                    }
                })
            },
            ListReasons() {
                _sFrzCtnResponsibleStopService.listdetail({ CrpID: 0 }, this.$fun.getUserID())
                .then(resp => {
                    if(resp.status == 200) {
                        this.itemReason = resp.data;
                    }
                })
            },
        },
        created() {
            this.ListResponsible();
            this.ListReasons();
        }
    }
</script>

<style scoped>
.modern-stop-card {
    border-radius: 16px !important;
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    overflow: hidden;
}

.modern-header {
    background: #007BFF;
    color: white;
    padding: 20px 24px;
    position: relative;
}

.header-title {
    font-size: 1.3rem;
    font-weight: 600;
    letter-spacing: 0.5px;
}

.close-btn {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(10px);
    border-radius: 50%;
    transition: all 0.3s ease;
}

.close-btn:hover {
    background: rgba(255, 255, 255, 0.2);
    transform: scale(1.1);
}

.modern-content {
    padding: 24px;
    background: white;
}

.form-section {
    margin-bottom: 24px;
    padding: 16px;
    background: #f8f9fa;
    border-radius: 12px;
    border-left: 4px solid #667eea;
}

.form-section:last-child {
    margin-bottom: 0;
}

.section-title {
    color: #2c3e50;
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 5px;
    display: flex;
    align-items: center;
}

.form-row {
    margin-top: 8px;
}

.input-container {
    position: relative;
}

.input-container >>> .v-input {
    background: white;
    border-radius: 8px;
}

.input-container >>> .v-input__slot {
    border-radius: 8px !important;
}

.input-container >>> .v-text-field--outlined fieldset {
    border-color: #e0e0e0;
    border-width: 1px;
}

.input-container >>> .v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) .v-input__slot:hover fieldset {
    border-color: #667eea;
}

.input-container >>> .v-text-field--outlined.v-input--is-focused fieldset {
    border-color: #667eea;
    border-width: 2px;
}

.modern-actions {
    background: #f8f9fa;
    padding: 16px 24px;
    border-top: 1px solid #e0e0e0;
}

.cancel-btn {
    font-weight: 500;
    text-transform: none;
    border-radius: 8px;
    padding: 0 16px;
}

.save-btn {
    background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%) !important;
    color: white !important;
    font-weight: 600;
    text-transform: none;
    border-radius: 8px;
    padding: 0 24px;
    transition: all 0.3s ease;
}

.save-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(76, 175, 80, 0.4) !important;
}

.save-btn:active {
    transform: translateY(0);
}

/* Animaciones */
.modern-stop-card {
    animation: slideIn 0.3s ease-out;
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateY(-20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* Responsive */
@media (max-width: 600px) {
    .modern-header {
        padding: 16px 20px;
    }
    
    .header-title {
        font-size: 1.1rem;
    }
    
    .modern-content {
        padding: 16px;
    }
    
    .form-section {
        padding: 12px;
        margin-bottom: 16px;
    }
    
    .section-title {
        font-size: 1rem;
    }
}
</style>